export default "__VITE_ASSET__62d1669f__"